import { EditorContext } from "./EditorContext.js";
export * from "./commands.js";
import { useEditorAPI } from "./hooks/useEditorAPI.js";
import { useEditorData } from "./hooks/useEditorData.js";
import { validateTidalLicense } from "../../../base/index.js";
validateTidalLicense();
export {
  EditorContext,
  useEditorAPI,
  useEditorData
};
//# sourceMappingURL=index.js.map
